export default __webpack_public_path__ + "static/media/3.49c7df6e.svg";